const PLUGIN_TOOLBAR_BUTTON_ID = {
  DELETE: "delete",
  ALIGNMENT: "alignment",
  SETTINGS: "settings",
  SETTINGS_WITH_LABEL: "settings-with-label",
  REPLACE: "replace",
  LINK: "link",
  SIZE: "size",
  SEPARATOR: "separator"
};
export {
  PLUGIN_TOOLBAR_BUTTON_ID
};
//# sourceMappingURL=plugin-toolbar-buttons-ids.js.map
